import { FC, useEffect, useRef, useState } from 'react';

// Grade curada de emojis comuns pra avatar — evita depender de lib externa
// (emoji-picker-react) e mantém o bundle leve.
const PRESET_EMOJIS = [
  '🤖', '🧠', '💡', '📊', '📈', '📚', '🔎', '🗂️',
  '⚙️', '🛠️', '🧮', '💬', '📝', '🎯', '🚀', '🧩',
  '⚖️', '🏭', '🧪', '💰', '📦', '🩺', '🌱', '🔐',
];

interface Props {
  value: string;
  onChange: (emoji: string) => void;
}

const EmojiAvatarPicker: FC<Props> = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        data-testid="emoji-avatar-button"
        aria-label="Escolher avatar"
        onClick={() => setOpen((o) => !o)}
        className="w-16 h-16 text-4xl border-2 border-surface-border rounded-lg hover:border-accent transition flex items-center justify-center"
      >
        {value || '🤖'}
      </button>
      {open && (
        <div
          data-testid="emoji-grid"
          className="absolute z-50 mt-2 p-2 grid grid-cols-6 gap-1 rounded-lg bg-surface-card border border-surface-border shadow-2xl ring-1 ring-black/40 min-w-[260px]"
        >
          {PRESET_EMOJIS.map((emoji) => (
            <button
              key={emoji}
              type="button"
              onClick={() => {
                onChange(emoji);
                setOpen(false);
              }}
              className="w-9 h-9 text-2xl rounded hover:bg-surface-hover transition flex items-center justify-center"
            >
              {emoji}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmojiAvatarPicker;
